import { Link } from 'react-router-dom';

import certifiedByDefiSentry from '../images/certifiedByDefiSentry.png';
import discImg from '../images/discord-wht.svg';
import teleImg from '../images/telegram-icon.png';

export default function Footer() {

  const date = new Date();
  const currentYear = date.getUTCFullYear();

  return (

    <footer className="footer-2">
      <div data-w-id="72a8ac3e-23a4-6320-e781-8ca7db0a6b56" className="container-default-2">
        <div className="w-layout-grid footer-grid">
          <div id="w-node-_72a8ac3e-23a4-6320-e781-8ca7db0a6b58-db0a6b55" className="footer-column" >
            <Link to="/" className="footer-logo-container mg-bottom-24px w-inline-block" >
              <img src="images/biofi-logo.svg" alt="" className="footer-logo" />
            </Link>
            <p className="mg-bottom-32px">Decentralized identity for all</p>
            <div className="social-links-wrapper">
              <div className="social-links-wrapper">
                <a href="http://www.facebook.com/Finnovant" target="_blank" className="socialblock w-inline-block" >
                  <div className="text-block-5"></div>
                </a>
                <a href="https://www.twitter.com/Finnovant" target="_blank" className="socialblock w-inline-block" >
                  <div className="text-block-5"></div>
                </a>
                <a href="https://www.instagram.com/finnovant_" target="_blank" className="socialblock w-inline-block">
                  <div className="text-block-5"></div>
                </a>
                <a href="https://www.youtube.com/channel/UCOTwEWk0PGXjaS-ihxeLQCg" target="_blank" className="socialblock w-inline-block">
                  <div className="text-block-5"></div>
                </a>
                <a href="https://discord.gg/QetRbRFrnP" target="_blank" className="socialblock w-inline-block" >
                  <img src={discImg} height="20px" alt="" className="image-2" />
                </a>
                <a href="http://t.me/bioficommunity" target="_blank" className="socialblock w-inline-block">
                  <img src={teleImg} height={20} alt="" className="image-2" />
                </a>
                <a href="https://www.linkedin.com/company/finnovant/" className="social-link linkedinIconStyle">
                  
                </a>
              </div>
            </div>
          </div>
          <div id="w-node-_72a8ac3e-23a4-6320-e781-8ca7db0a6b6d-db0a6b55" className="footer-column middle" >
            <div className="footer-nav-main-wrapper">
              <div className="footer-title">Ecosystem</div>
              <div className="footer-nav-wrapper">
                <ul role="list" className="footer-nav">
                  <li className="footer-nav-item">
                    <a href="https://biometricfinancial.org/" className="footer-link-2" >
                      Products &amp;&nbsp;Services
                    </a>
                  </li>
                  <li className="footer-nav-item">
                    <a href="https://biometricfinancial.org/phenixloc/" className="footer-link-2">
                      PhenixLoc
                    </a>
                  </li>
                  <li className="footer-nav-item">
                    <a href="https://biometricfinancial.org/say-tec/" className="footer-link-2" >
                      Say-Tec
                    </a>
                  </li>
                  <li className="footer-nav-item">
                    <a href="https://biometricfinancial.org/krptic/" className="footer-link-2">
                      Krptic
                    </a>
                  </li>
                  <li className="footer-nav-item">
                    <a href="https://biometricfinancial.org/phenix-x/" className="footer-link-2">
                      Phēnix X
                    </a>
                  </li>
                  <li className="footer-nav-item">
                    <a href="https://biometricfinancial.org/build/" className="footer-link-2">
                      Build
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="footer-nav-main-wrapper">
              <div className="footer-title">Learn</div>
              <div className="footer-nav-wrapper">
                <ul role="list" className="footer-nav">
                  <li className="footer-nav-item">
                    <a href="https://biometricfinancial.org/wp-content/uploads/BioFi_Whitepaper.pdf" target="_blank" className="footer-link-2">
                      WhitePaper
                    </a>
                  </li>
                  <li className="footer-nav-item">
                    <a href="https://biometricfinancial.org/wp-content/uploads/BioFi-OnePager.pdf" target="_blank" className="footer-link-2">
                      One Pager
                    </a>
                  </li>
                  <li className="footer-nav-item">
                    <a href="https://biometricfinancial.org/wp-content/uploads/BioFi-ThreePager.pdf" target="_blank" className="footer-link-2">
                      Three Pager
                    </a>
                  </li>
                  <li className="footer-nav-item">
                    <a href="https://biometricfinancial.org/biofi-tokenomics/" className="footer-link-2">
                      Tokenomics
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="footer-nav-main-wrapper last">
              <div className="footer-title">
                <a href="https://biometricfinancial.org/about-us/" className="link-2">
                  About
                </a>
              </div>
              <div className="footer-nav-wrapper">
                <ul role="list" className="footer-nav">
                  <li className="footer-nav-item">
                    <a href="https://biometricfinancial.org/faqs/" className="footer-link-2">
                      FAQ
                    </a>
                  </li>
                  <li className="footer-nav-item">
                    <a href="https://finnovant.com/newsletters/" className="footer-link-2">
                      Press
                    </a>
                  </li>
                  <li className="footer-nav-item">
                    <a href="https://biometricfinancial.org/about-us/#team" className="footer-link-2">
                      Team
                    </a>
                  </li>
                  <li className="footer-nav-item last">
                    <a href="https://biometricfinancial.org/contact-us/" className="footer-link-2">
                      Contact Us
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div id="w-node-_72a8ac3e-23a4-6320-e781-8ca7db0a6b58-db0a6b55" className="footer-column" style={{ paddingLeft: "5em" }}>
            <p className="mg-bottom-32px" style={{ fontSize: "1.15em", fontWeight: 500, letterSpacing: ".05rem" }}>
              Do you know a company that would be interested in becoming a provider
              in the BioFi Ecosystem? Click the button below.
            </p>
            <a href="https://biometricfinancial.org/forms/provider-referral/" target="_blank" className="providerReferralButton">
              Provider Referral
            </a>
          </div>
        </div>
        <div className="divider bg-neutral-600" />
        <div className="footer-bottom-content">
          <div>
            Copyright © 2022-{currentYear} Biometricfinancial.org All rights reserved |{" "}
            <a href="https://biometricfinancial.org/privacy-policy/" className="link-3">
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
      <div className="defisentrybadge">
        <a href="/content/BioFi_letter_1 Defi_Sentry_Audit_Certification_03162023.pdf" target="_blank" className="w-inline-block" style={{ float: "right", textDecoration: "none" }}>
          <img src={certifiedByDefiSentry} alt="" className="image-10"/>
        </a>
      </div>
    </footer>

  );
}